
import { mapState } from 'vuex';
import { defineComponent } from 'vue';
import { getVehicleListByType } from '@/api/apis';
import { baseFileUrl } from '@/utils/constants';

export default defineComponent({
  name: 'ProductSection',
  props: {
    vehicleTypes: {
      type: Array,
      required: true,
      default: () => []
    },
    loaded: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(['lang'])
  },
  watch: {
    lang() {
      const prods = Array.from(document.querySelectorAll('.product-action'));
      prods.forEach(p => {
        (p as any).style.width = 'auto';
      });
      this.isProdActionWidthSet = false;
    }
  },
  data(): any {
    const selectedType =
      this.vehicleTypes.length > 0 ? (this.vehicleTypes[0] as any).id : 0;
    return {
      selectedType,
      products: [],
      selfLoaded: false,
      isProdActionWidthSet: false
    };
  },
  updated() {
    this.calculateImg();

    // 找到所有item
    if (!this.isProdActionWidthSet) {
      setTimeout(() => {
        const prods = Array.from(document.querySelectorAll('.product-action'));

        const widths = prods.map(p => p.clientWidth);

        // 找到最大的

        const maxWidth = Math.max(...widths);

        prods.forEach(p => {
          (p as any).style.width = `${maxWidth}px`;
        });
      }, 500);
      this.isProdActionWidthSet = true;
    }
  },
  created() {
    this.loadData();

    this.$bus.$on('calculate-img', this.calculateImg);
  },
  methods: {
    calculateImg() {
      const imgs: any[] = Array.from(document.querySelectorAll('.product-img'));

      imgs.forEach(e => {
        if (e.parentElement) {
          e.style.height = `${(e.parentElement?.offsetWidth * 5) / 8}px`;
        }
      });
    },
    gotoProd(vehicle) {
      this.$router.push(`/products?vehicleType=${vehicle.vehicleType}`);
    },
    getImg(product) {
      const showImgs = (product.showImg || '').split(',').filter(s => s);
      return showImgs.length > 0 ? baseFileUrl + showImgs[0] : '';
    },
    async loadData() {
      if (this.selectedType > 0) {
        const res = await getVehicleListByType({
          type: this.selectedType
        });

        if (res.success) {
          this.products = res.result || [];
        }
      }

      this.selfLoaded = true;
    },
    handleTypeChange(id) {
      if (id !== this.selectedType) {
        this.selectedType = id;
        this.selfLoaded = false;

        this.loadData();
      }
    }
  }
});
